webpackJsonp([5,129,130,131,220,221,222,223,224,225,226,227,228,284,285],{

/***/ 1073:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "label": "Name"
    }
  }, [_c('b-input', {
    attrs: {
      "value": "Kevin Garvey"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Email",
      "type": "is-danger",
      "message": "This email is invalid"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "email",
      "value": "john@",
      "maxlength": "30"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Username",
      "type": "is-success",
      "message": "This username is available"
    }
  }, [_c('b-input', {
    attrs: {
      "value": "johnsilver",
      "maxlength": "30"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Password",
      "type": "is-warning",
      "message": ['Password is too short', 'Password must have at least 8 characters']
    }
  }, [_c('b-input', {
    attrs: {
      "value": "123",
      "type": "password",
      "maxlength": "30"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Subject"
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select a subject"
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Option 1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Option 2")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1074:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            hasError: true
        };
    }
});

/***/ }),

/***/ 1075:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-checkbox', {
    model: {
      value: (_vm.hasError),
      callback: function($$v) {
        _vm.hasError = $$v
      },
      expression: "hasError"
    }
  }, [_vm._v("Show errors")]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Username",
      "type": {
        'is-danger': _vm.hasError
      },
      "message": {
        'Username is not available': _vm.hasError
      }
    }
  }, [_c('b-input', {
    attrs: {
      "value": "johnsilver",
      "maxlength": "30"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Password",
      "type": {
        'is-danger': _vm.hasError
      },
      "message": [{
          'Password is too short': _vm.hasError
        },
        {
          'Password must have at least 8 characters': _vm.hasError
        }
      ]
    }
  }, [_c('b-input', {
    attrs: {
      "value": "123",
      "type": "password",
      "maxlength": "30"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1076:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Search...",
      "type": "search",
      "icon": "magnify"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary"
  }, [_vm._v("Search")])])], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "This is expanded",
      "expanded": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "button is-static"
  }, [_vm._v("@gmail.com")])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-field', [_c('b-select', {
    attrs: {
      "placeholder": "Currency"
    }
  }, [_c('option', [_vm._v("$")]), _vm._v(" "), _c('option', [_vm._v("£")]), _vm._v(" "), _c('option', [_vm._v("€")])]), _vm._v(" "), _c('b-input', {
    attrs: {
      "type": "number",
      "placeholder": "0,00"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-success"
  }, [_vm._v("Transfer")])])], 1), _vm._v(" "), _c('b-field', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button"
  }, [_c('b-icon', {
    attrs: {
      "icon": "format-bold"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button"
  }, [_c('b-icon', {
    attrs: {
      "icon": "format-italic"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button"
  }, [_c('b-icon', {
    attrs: {
      "icon": "format-underline"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button"
  }, [_c('b-icon', {
    attrs: {
      "icon": "format-align-left"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button"
  }, [_c('b-icon', {
    attrs: {
      "icon": "format-align-center"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button"
  }, [_c('b-icon', {
    attrs: {
      "icon": "format-align-right"
    }
  })], 1)]), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "Search...",
      "type": "search",
      "icon": "magnify"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary"
  }, [_vm._v("\n                    Button\n                ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('b-dropdown', [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('b-icon', {
    attrs: {
      "icon": "menu-down"
    }
  })], 1), _vm._v(" "), _c('b-dropdown-item', [_vm._v("Action")]), _vm._v(" "), _c('b-dropdown-item', [_vm._v("Another action")]), _vm._v(" "), _c('b-dropdown-item', [_vm._v("Something else")])], 1)], 1)]), _vm._v(" "), _c('b-field', [_c('p', {
    staticClass: "control"
  }, [_c('b-dropdown', [_c('button', {
    staticClass: "button",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('span', [_vm._v("Filters")]), _vm._v(" "), _c('b-icon', {
    attrs: {
      "icon": "menu-down"
    }
  })], 1), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "open_issues"
    }
  }, [_vm._v("Open Issues and Pull Requests")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "your_issues"
    }
  }, [_vm._v("Your Issues")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "pull_requests"
    }
  }, [_vm._v("Your Pull Requests")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "everything"
    }
  }, [_vm._v("Everything")])], 1)], 1), _vm._v(" "), _c('b-input', {
    attrs: {
      "icon": "magnify",
      "type": "search",
      "placeholder": "Search..."
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1077:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": ""
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Search..."
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary"
  }, [_vm._v("Search")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": ""
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Search...",
      "expanded": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary"
  }, [_vm._v("Search")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1078:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-field', {
    attrs: {
      "grouped": ""
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Personal title"
    }
  }, [_c('b-select', [_c('option', [_vm._v("Mr.")]), _vm._v(" "), _c('option', [_vm._v("Ms.")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Name",
      "expanded": ""
    }
  }, [_c('b-input')], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Email",
      "expanded": ""
    }
  }, [_c('b-input')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1079:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('b-input'), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("First")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("Second")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("Third")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("Fourth")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("Fifth")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("Sixth")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("Seventh")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("Eighth")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1080:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "position": "is-centered"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Search...",
      "type": "search",
      "icon": "magnify"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-info"
  }, [_vm._v("Search")])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": "",
      "position": "is-right"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Search...",
      "type": "search",
      "icon": "magnify"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-info"
  }, [_vm._v("Search")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1081:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-field', {
    attrs: {
      "grouped": ""
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Name",
      "expanded": ""
    }
  }, [_c('b-field', [_c('b-select', {
    attrs: {
      "placeholder": "Title"
    }
  }, [_c('option', [_vm._v("Mr.")]), _vm._v(" "), _c('option', [_vm._v("Ms.")])]), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "Name",
      "expanded": ""
    }
  })], 1)], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Email",
      "expanded": ""
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "some@email.com"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1082:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "horizontal": "",
      "label": "Subject",
      "type": "is-danger",
      "message": "Please enter a subject"
    }
  }, [_c('b-input', {
    attrs: {
      "name": "subject",
      "expanded": ""
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "horizontal": "",
      "label": "From"
    }
  }, [_c('b-input', {
    attrs: {
      "name": "name",
      "placeholder": "Name",
      "expanded": ""
    }
  }), _vm._v(" "), _c('b-input', {
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "nobody@nowhere.com",
      "expanded": ""
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "horizontal": "",
      "label": "Topic"
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select a topic"
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Bulma")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Vue.js")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Buefy")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "horizontal": "",
      "label": "Message"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "textarea"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "horizontal": ""
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary"
  }, [_vm._v("\n                  Send message\n                ")])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1083:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            firstClass: 'has-text-primary',
            secondClass: 'is-medium'
        };
    },

    computed: {
        classes: function classes() {
            return this.firstClass + ' ' + this.secondClass;
        }
    }
});

/***/ }),

/***/ 1084:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "label": "Small",
      "custom-class": "is-small"
    }
  }, [_c('b-input', {
    attrs: {
      "value": "Kevin Garvey",
      "size": "is-small"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Large",
      "custom-class": "is-large"
    }
  }, [_c('b-input', {
    attrs: {
      "value": "Kevin Garvey",
      "size": "is-large"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Danger",
      "custom-class": "has-text-danger",
      "type": "is-danger",
      "message": "This email is invalid"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "email",
      "value": "john@",
      "maxlength": "30"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Multiple (small and success)",
      "custom-class": "is-small has-text-success",
      "type": "is-success"
    }
  }, [_c('b-input', {
    attrs: {
      "value": "johnsilver",
      "maxlength": "30",
      "size": "is-small"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Computed (medium and primary)",
      "custom-class": _vm.classes,
      "type": "is-primary"
    }
  }, [_c('b-input', {
    attrs: {
      "value": "johnsilver",
      "maxlength": "30",
      "size": "is-medium"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1085:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "custom-class": "is-medium",
      "horizontal": ""
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n               With tooltip\n                "), _c('b-tooltip', {
    attrs: {
      "type": "is-dark",
      "label": "Help text here for explanation"
    }
  }, [_c('b-icon', {
    attrs: {
      "size": "is-small",
      "icon": "help-circle-outline"
    }
  })], 1)], 1), _vm._v(" "), _c('b-input', {
    attrs: {
      "size": "is-medium"
    }
  })], 2), _vm._v(" "), _c('b-field', [_c('template', {
    slot: "label"
  }, [_vm._v("\n                Label with custom "), _c('span', {
    staticClass: "has-text-primary is-italic"
  }, [_vm._v("style")])]), _vm._v(" "), _c('b-input')], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1086:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            labelPosition: 'on-border'
        };
    }
});

/***/ }),

/***/ 1087:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "block"
  }, [_c('b-radio', {
    attrs: {
      "native-value": "on-border"
    },
    model: {
      value: (_vm.labelPosition),
      callback: function($$v) {
        _vm.labelPosition = $$v
      },
      expression: "labelPosition"
    }
  }, [_vm._v("\n                On Border\n            ")]), _vm._v(" "), _c('b-radio', {
    attrs: {
      "native-value": "inside"
    },
    model: {
      value: (_vm.labelPosition),
      callback: function($$v) {
        _vm.labelPosition = $$v
      },
      expression: "labelPosition"
    }
  }, [_vm._v("\n                Inside\n            ")])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Name",
      "label-position": _vm.labelPosition
    }
  }, [_c('b-input', {
    attrs: {
      "value": "Kevin Garvey"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Email",
      "label-position": _vm.labelPosition,
      "type": "is-danger",
      "message": "This email is invalid"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "email",
      "value": "john@",
      "maxlength": "30"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Username",
      "label-position": _vm.labelPosition,
      "type": "is-success",
      "message": "This username is available"
    }
  }, [_c('b-input', {
    attrs: {
      "value": "johnsilver",
      "maxlength": "30"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Password",
      "label-position": _vm.labelPosition,
      "type": "is-warning",
      "message": ['Password is too short', 'Password must have at least 8 characters']
    }
  }, [_c('b-input', {
    attrs: {
      "value": "123",
      "type": "password",
      "maxlength": "30"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Subject",
      "label-position": _vm.labelPosition
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select a subject"
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Option 1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Option 2")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Message",
      "label-position": _vm.labelPosition
    }
  }, [_c('b-input', {
    attrs: {
      "maxlength": "200",
      "type": "textarea"
    }
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "title is-6"
  }, [_vm._v("Also works for grouped field and with addons.")]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Search...",
      "label-position": _vm.labelPosition,
      "grouped": ""
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Search...",
      "type": "search"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('b-button', {
    staticClass: "button is-primary"
  }, [_vm._v("Search")])], 1)], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Search...",
      "label-position": _vm.labelPosition
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Search...",
      "type": "search"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('b-button', {
    staticClass: "button is-primary"
  }, [_vm._v("Search")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_field__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__variables_field__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__examples_ExObjectSyntax__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__examples_ExObjectSyntax___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__examples_ExObjectSyntax__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExObjectSyntax__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExObjectSyntax___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExObjectSyntax__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__examples_ExAddons__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__examples_ExAddons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__examples_ExAddons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExAddons__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExAddons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExAddons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__examples_ExGroups__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__examples_ExGroups___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__examples_ExGroups__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExGroups__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExGroups___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExGroups__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__examples_ExGroupExpanded__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__examples_ExGroupExpanded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__examples_ExGroupExpanded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__raw_loader_examples_ExGroupExpanded__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__raw_loader_examples_ExGroupExpanded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__raw_loader_examples_ExGroupExpanded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__examples_ExGroupMultiline__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__examples_ExGroupMultiline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__examples_ExGroupMultiline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__raw_loader_examples_ExGroupMultiline__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__raw_loader_examples_ExGroupMultiline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__raw_loader_examples_ExGroupMultiline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__examples_ExPositions__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__examples_ExPositions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__examples_ExPositions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__raw_loader_examples_ExPositions__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__raw_loader_examples_ExPositions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__raw_loader_examples_ExPositions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__examples_ExCombineAddonsGroups__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__examples_ExCombineAddonsGroups___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__examples_ExCombineAddonsGroups__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__raw_loader_examples_ExCombineAddonsGroups__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__raw_loader_examples_ExCombineAddonsGroups___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__raw_loader_examples_ExCombineAddonsGroups__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__examples_ExHorizontal__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__examples_ExHorizontal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__examples_ExHorizontal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__raw_loader_examples_ExHorizontal__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__raw_loader_examples_ExHorizontal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__raw_loader_examples_ExHorizontal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__examples_ExCustomClass__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__examples_ExCustomClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__examples_ExCustomClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__raw_loader_examples_ExCustomClass__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__raw_loader_examples_ExCustomClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__raw_loader_examples_ExCustomClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__examples_ExLabelSlot__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__examples_ExLabelSlot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__examples_ExLabelSlot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__raw_loader_examples_ExLabelSlot__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__raw_loader_examples_ExLabelSlot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__raw_loader_examples_ExLabelSlot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__examples_ExLabelPosition__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__examples_ExLabelPosition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__examples_ExLabelPosition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__raw_loader_examples_ExLabelPosition__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__raw_loader_examples_ExLabelPosition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__raw_loader_examples_ExLabelPosition__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








































/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            api: __WEBPACK_IMPORTED_MODULE_0__api_field__["default"],
            variables: __WEBPACK_IMPORTED_MODULE_1__variables_field__["default"],
            ExSimple: __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple___default.a,
            ExObjectSyntax: __WEBPACK_IMPORTED_MODULE_4__examples_ExObjectSyntax___default.a,
            ExAddons: __WEBPACK_IMPORTED_MODULE_6__examples_ExAddons___default.a,
            ExGroups: __WEBPACK_IMPORTED_MODULE_8__examples_ExGroups___default.a,
            ExGroupExpanded: __WEBPACK_IMPORTED_MODULE_10__examples_ExGroupExpanded___default.a,
            ExGroupMultiline: __WEBPACK_IMPORTED_MODULE_12__examples_ExGroupMultiline___default.a,
            ExPositions: __WEBPACK_IMPORTED_MODULE_14__examples_ExPositions___default.a,
            ExCombineAddonsGroups: __WEBPACK_IMPORTED_MODULE_16__examples_ExCombineAddonsGroups___default.a,
            ExHorizontal: __WEBPACK_IMPORTED_MODULE_18__examples_ExHorizontal___default.a,
            ExCustomClass: __WEBPACK_IMPORTED_MODULE_20__examples_ExCustomClass___default.a,
            ExLabelSlot: __WEBPACK_IMPORTED_MODULE_22__examples_ExLabelSlot___default.a,
            ExLabelPosition: __WEBPACK_IMPORTED_MODULE_24__examples_ExLabelPosition___default.a,
            ExSimpleCode: __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple___default.a,
            ExObjectSyntaxCode: __WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExObjectSyntax___default.a,
            ExAddonsCode: __WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExAddons___default.a,
            ExGroupsCode: __WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExGroups___default.a,
            ExGroupExpandedCode: __WEBPACK_IMPORTED_MODULE_11__raw_loader_examples_ExGroupExpanded___default.a,
            ExGroupMultilineCode: __WEBPACK_IMPORTED_MODULE_13__raw_loader_examples_ExGroupMultiline___default.a,
            ExPositionsCode: __WEBPACK_IMPORTED_MODULE_15__raw_loader_examples_ExPositions___default.a,
            ExCombineAddonsGroupsCode: __WEBPACK_IMPORTED_MODULE_17__raw_loader_examples_ExCombineAddonsGroups___default.a,
            ExHorizontalCode: __WEBPACK_IMPORTED_MODULE_19__raw_loader_examples_ExHorizontal___default.a,
            ExCustomClassCode: __WEBPACK_IMPORTED_MODULE_21__raw_loader_examples_ExCustomClass___default.a,
            ExLabelSlotCode: __WEBPACK_IMPORTED_MODULE_23__raw_loader_examples_ExLabelSlot___default.a,
            ExLabelPositionCode: __WEBPACK_IMPORTED_MODULE_25__raw_loader_examples_ExLabelPosition___default.a
        };
    }
});

/***/ }),

/***/ 1392:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field label=\"Name\">\n            <b-input value=\"Kevin Garvey\"></b-input>\n        </b-field>\n\n        <b-field label=\"Email\"\n            type=\"is-danger\"\n            message=\"This email is invalid\">\n            <b-input type=\"email\"\n                value=\"john@\"\n                maxlength=\"30\">\n            </b-input>\n        </b-field>\n\n        <b-field label=\"Username\"\n            type=\"is-success\"\n            message=\"This username is available\">\n            <b-input value=\"johnsilver\" maxlength=\"30\"></b-input>\n        </b-field>\n\n        <b-field label=\"Password\"\n            type=\"is-warning\"\n            :message=\"['Password is too short', 'Password must have at least 8 characters']\">\n            <b-input value=\"123\" type=\"password\" maxlength=\"30\"></b-input>\n        </b-field>\n\n        <b-field label=\"Subject\">\n            <b-select placeholder=\"Select a subject\">\n                <option value=\"1\">Option 1</option>\n                <option value=\"2\">Option 2</option>\n            </b-select>\n        </b-field>\n    </section>\n</template>\n"

/***/ }),

/***/ 1393:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-checkbox v-model=\"hasError\">Show errors</b-checkbox>\n\n        <b-field label=\"Username\"\n            :type=\"{ 'is-danger': hasError }\"\n            :message=\"{ 'Username is not available': hasError }\">\n            <b-input value=\"johnsilver\" maxlength=\"30\"></b-input>\n        </b-field>\n\n        <b-field label=\"Password\"\n            :type=\"{ 'is-danger': hasError }\"\n            :message=\"[\n                { 'Password is too short': hasError },\n                { 'Password must have at least 8 characters': hasError }\n            ]\">\n            <b-input value=\"123\" type=\"password\" maxlength=\"30\"></b-input>\n        </b-field>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                hasError: true\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1394:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field>\n            <b-input placeholder=\"Search...\"\n                type=\"search\"\n                icon=\"magnify\">\n            </b-input>\n            <p class=\"control\">\n                <button class=\"button is-primary\">Search</button>\n            </p>\n        </b-field>\n\n        <b-field>\n            <b-input placeholder=\"This is expanded\" expanded></b-input>\n            <p class=\"control\">\n                <span class=\"button is-static\">@gmail.com</span>\n            </p>\n        </b-field>\n\n        <hr>\n\n        <b-field>\n            <b-select placeholder=\"Currency\">\n                <option>$</option>\n                <option>£</option>\n                <option>€</option>\n            </b-select>\n            <b-input type=\"number\" placeholder=\"0,00\"></b-input>\n            <p class=\"control\">\n                <button class=\"button is-success\">Transfer</button>\n            </p>\n        </b-field>\n\n        <b-field>\n            <p class=\"control\">\n                <button class=\"button\">\n                    <b-icon icon=\"format-bold\"></b-icon>\n                </button>\n            </p>\n            <p class=\"control\">\n                <button class=\"button\">\n                    <b-icon icon=\"format-italic\"></b-icon>\n                </button>\n            </p>\n            <p class=\"control\">\n                <button class=\"button\">\n                    <b-icon icon=\"format-underline\"></b-icon>\n                </button>\n            </p>\n            <p class=\"control\">\n                <button class=\"button\">\n                    <b-icon icon=\"format-align-left\"></b-icon>\n                </button>\n            </p>\n            <p class=\"control\">\n                <button class=\"button\">\n                    <b-icon icon=\"format-align-center\"></b-icon>\n                </button>\n            </p>\n            <p class=\"control\">\n                <button class=\"button\">\n                    <b-icon icon=\"format-align-right\"></b-icon>\n                </button>\n            </p>\n            <b-input placeholder=\"Search...\" type=\"search\" icon=\"magnify\"></b-input>\n        </b-field>\n\n        <b-field>\n            <p class=\"control\">\n                <button class=\"button is-primary\">\n                    Button\n                </button>\n            </p>\n            <p class=\"control\">\n                <b-dropdown>\n                    <button class=\"button is-primary\" slot=\"trigger\">\n                        <b-icon icon=\"menu-down\"></b-icon>\n                    </button>\n\n                    <b-dropdown-item>Action</b-dropdown-item>\n                    <b-dropdown-item>Another action</b-dropdown-item>\n                    <b-dropdown-item>Something else</b-dropdown-item>\n                </b-dropdown>\n            </p>\n        </b-field>\n\n        <b-field>\n            <p class=\"control\">\n                <b-dropdown>\n                    <button class=\"button\" slot=\"trigger\">\n                        <span>Filters</span>\n                        <b-icon icon=\"menu-down\"></b-icon>\n                    </button>\n\n                    <b-dropdown-item value=\"open_issues\">Open Issues and Pull Requests</b-dropdown-item>\n                    <b-dropdown-item value=\"your_issues\">Your Issues</b-dropdown-item>\n                    <b-dropdown-item value=\"pull_requests\">Your Pull Requests</b-dropdown-item>\n                    <b-dropdown-item value=\"everything\">Everything</b-dropdown-item>\n                </b-dropdown>\n            </p>\n            <b-input icon=\"magnify\" type=\"search\" placeholder=\"Search...\"></b-input>\n        </b-field>\n    </section>\n</template>\n"

/***/ }),

/***/ 1395:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field grouped>\n            <b-input placeholder=\"Search...\"></b-input>\n            <p class=\"control\">\n                <button class=\"button is-primary\">Search</button>\n            </p>\n        </b-field>\n\n        <b-field grouped>\n            <b-input placeholder=\"Search...\" expanded></b-input>\n            <p class=\"control\">\n                <button class=\"button is-primary\">Search</button>\n            </p>\n        </b-field>\n    </section>\n</template>\n"

/***/ }),

/***/ 1396:
/***/ (function(module, exports) {

module.exports = "<template>\n    <b-field grouped>\n        <b-field label=\"Personal title\">\n            <b-select>\n                <option>Mr.</option>\n                <option>Ms.</option>\n            </b-select>\n        </b-field>\n        <b-field label=\"Name\" expanded>\n            <b-input></b-input>\n        </b-field>\n        <b-field label=\"Email\" expanded>\n            <b-input></b-input>\n        </b-field>\n    </b-field>\n</template>\n"

/***/ }),

/***/ 1397:
/***/ (function(module, exports) {

module.exports = "<template>\n    <b-field grouped group-multiline>\n        <b-input></b-input>\n        <p class=\"control\">\n            <button class=\"button\">First</button>\n        </p>\n        <p class=\"control\">\n            <button class=\"button\">Second</button>\n        </p>\n        <p class=\"control\">\n            <button class=\"button\">Third</button>\n        </p>\n        <p class=\"control\">\n            <button class=\"button\">Fourth</button>\n        </p>\n        <p class=\"control\">\n            <button class=\"button\">Fifth</button>\n        </p>\n        <p class=\"control\">\n            <button class=\"button\">Sixth</button>\n        </p>\n        <p class=\"control\">\n            <button class=\"button\">Seventh</button>\n        </p>\n        <p class=\"control\">\n            <button class=\"button\">Eighth</button>\n        </p>\n    </b-field>\n</template>\n"

/***/ }),

/***/ 1398:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field position=\"is-centered\">\n            <b-input placeholder=\"Search...\" type=\"search\" icon=\"magnify\">\n            </b-input>\n            <p class=\"control\">\n                <button class=\"button is-info\">Search</button>\n            </p>\n        </b-field>\n\n        <hr>\n\n        <b-field grouped position=\"is-right\">\n            <b-input placeholder=\"Search...\" type=\"search\" icon=\"magnify\">\n            </b-input>\n            <p class=\"control\">\n                <button class=\"button is-info\">Search</button>\n            </p>\n        </b-field>\n    </section>\n</template>\n"

/***/ }),

/***/ 1399:
/***/ (function(module, exports) {

module.exports = "<template>\n    <b-field grouped>\n        <b-field label=\"Name\" expanded>\n            <b-field>\n                <b-select placeholder=\"Title\">\n                    <option>Mr.</option>\n                    <option>Ms.</option>\n                </b-select>\n                <b-input placeholder=\"Name\" expanded></b-input>\n            </b-field>\n        </b-field>\n        <b-field label=\"Email\" expanded>\n            <b-input placeholder=\"some@email.com\"></b-input>\n        </b-field>\n    </b-field>\n</template>\n"

/***/ }),

/***/ 1400:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field horizontal label=\"Subject\" type=\"is-danger\" message=\"Please enter a subject\">\n            <b-input name=\"subject\" expanded></b-input>\n        </b-field>\n\n        <b-field horizontal label=\"From\">\n            <b-input name=\"name\" placeholder=\"Name\" expanded></b-input>\n            <b-input name=\"email\" type=\"email\" placeholder=\"nobody@nowhere.com\" expanded></b-input>\n        </b-field>\n\n        <b-field horizontal label=\"Topic\">\n            <b-select placeholder=\"Select a topic\">\n                <option value=\"1\">Bulma</option>\n                <option value=\"2\">Vue.js</option>\n                <option value=\"3\">Buefy</option>\n            </b-select>\n        </b-field>\n\n        <b-field horizontal label=\"Message\">\n            <b-input type=\"textarea\"></b-input>\n        </b-field>\n\n        <b-field horizontal><!-- Label left empty for spacing -->\n            <p class=\"control\">\n                <button class=\"button is-primary\">\n                  Send message\n                </button>\n            </p>\n        </b-field>\n\n    </section>\n</template>\n"

/***/ }),

/***/ 1401:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field label=\"Small\" custom-class=\"is-small\">\n            <b-input value=\"Kevin Garvey\" size=\"is-small\"></b-input>\n        </b-field>\n        <b-field label=\"Large\" custom-class=\"is-large\">\n            <b-input value=\"Kevin Garvey\" size=\"is-large\"></b-input>\n        </b-field>\n\n        <b-field label=\"Danger\"\n            custom-class=\"has-text-danger\"\n            type=\"is-danger\"\n            message=\"This email is invalid\">\n            <b-input type=\"email\"\n                value=\"john@\"\n                maxlength=\"30\">\n            </b-input>\n        </b-field>\n\n        <b-field label=\"Multiple (small and success)\"\n            custom-class=\"is-small has-text-success\"\n            type=\"is-success\"\n            >\n            <b-input value=\"johnsilver\" maxlength=\"30\" size=\"is-small\"></b-input>\n        </b-field>\n\n        <b-field label=\"Computed (medium and primary)\"\n            :custom-class=\"classes\"\n            type=\"is-primary\"\n            >\n            <b-input value=\"johnsilver\" maxlength=\"30\" size=\"is-medium\"></b-input>\n        </b-field>\n\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                firstClass: 'has-text-primary',\n                secondClass: 'is-medium'\n            }\n        },\n        computed: {\n            classes() {\n                return `${this.firstClass} ${this.secondClass}`\n            }\n        }\n    }\n</script>"

/***/ }),

/***/ 1402:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field\n            custom-class=\"is-medium\"\n            horizontal>\n            <template slot=\"label\">\n               With tooltip\n                <b-tooltip type=\"is-dark\" label=\"Help text here for explanation\">\n                    <b-icon size=\"is-small\" icon=\"help-circle-outline\"></b-icon>\n                </b-tooltip>\n            </template>\n            <b-input size=\"is-medium\"></b-input>\n        </b-field>\n\n        <b-field>\n            <template slot=\"label\">\n                Label with custom <span class=\"has-text-primary is-italic\">style</span>\n            </template>\n            <b-input></b-input>\n        </b-field>\n    </section>\n</template>"

/***/ }),

/***/ 1403:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <div class=\"block\">\n            <b-radio v-model=\"labelPosition\"\n                native-value=\"on-border\">\n                On Border\n            </b-radio>\n            <b-radio v-model=\"labelPosition\"\n                native-value=\"inside\">\n                Inside\n            </b-radio>\n        </div>\n\n        <b-field label=\"Name\" :label-position=\"labelPosition\">\n            <b-input value=\"Kevin Garvey\"></b-input>\n        </b-field>\n\n        <b-field label=\"Email\"\n            :label-position=\"labelPosition\"\n            type=\"is-danger\"\n            message=\"This email is invalid\">\n            <b-input type=\"email\"\n                value=\"john@\"\n                maxlength=\"30\">\n            </b-input>\n        </b-field>\n\n        <b-field label=\"Username\"\n            :label-position=\"labelPosition\"\n            type=\"is-success\"\n            message=\"This username is available\">\n            <b-input value=\"johnsilver\" maxlength=\"30\"></b-input>\n        </b-field>\n\n        <b-field label=\"Password\"\n            :label-position=\"labelPosition\"\n            type=\"is-warning\"\n            :message=\"['Password is too short', 'Password must have at least 8 characters']\">\n            <b-input value=\"123\" type=\"password\" maxlength=\"30\"></b-input>\n        </b-field>\n\n        <b-field label=\"Subject\"\n            :label-position=\"labelPosition\">\n            <b-select placeholder=\"Select a subject\">\n                <option value=\"1\">Option 1</option>\n                <option value=\"2\">Option 2</option>\n            </b-select>\n        </b-field>\n\n        <b-field label=\"Message\"\n            :label-position=\"labelPosition\">\n            <b-input maxlength=\"200\" type=\"textarea\"></b-input>\n        </b-field>\n\n        <hr>\n        <p class=\"title is-6\">Also works for grouped field and with addons.</p>\n\n        <b-field label=\"Search...\" :label-position=\"labelPosition\" grouped>\n            <b-input placeholder=\"Search...\" type=\"search\"></b-input>\n            <p class=\"control\">\n                <b-button class=\"button is-primary\">Search</b-button>\n            </p>\n        </b-field>\n\n        <b-field label=\"Search...\" :label-position=\"labelPosition\">\n            <b-input placeholder=\"Search...\" type=\"search\"></b-input>\n            <p class=\"control\">\n                <b-button class=\"button is-primary\">Search</b-button>\n            </p>\n        </b-field>\n    </section>\n</template>\n\n<script>\nexport default {\n    data() {\n        return {\n            labelPosition: 'on-border'\n        }\n    }\n}\n</script>\n\n"

/***/ }),

/***/ 1404:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode,
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExLabelPosition,
      "code": _vm.ExLabelPositionCode,
      "title": "Label Position",
      "vertical": ""
    }
  }, [_c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag is-success"
  }, [_vm._v("New!")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v("0.7.8")])]), _vm._v(" "), _c('p', [_vm._v("Add the "), _c('code', [_vm._v("label-position")]), _vm._v(" prop to modify field style.")]), _vm._v(" "), _c('b-message', {
    attrs: {
      "type": "is-info"
    }
  }, [_vm._v("\n                You can set the "), _c('code', [_vm._v("defaultFieldLabelPosition")]), _vm._v(" constructor option to override the default style\n            ")])], 1), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExObjectSyntax,
      "code": _vm.ExObjectSyntaxCode,
      "title": "Object syntax",
      "vertical": ""
    }
  }, [_c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag is-success"
  }, [_vm._v("New!")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v("0.7.0")])]), _vm._v(" "), _c('p', [_vm._v("You can also use object syntax for "), _c('code', [_vm._v("type")]), _vm._v(" and "), _c('code', [_vm._v("message")]), _vm._v(" props just like Vuejs "), _c('code', [_vm._v("class")]), _vm._v(".")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExAddons,
      "code": _vm.ExAddonsCode,
      "title": "Addons",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("The above cited components are automatically attached together when inside a Field.")]), _vm._v(" "), _c('p', [_vm._v("Use the "), _c('code', [_vm._v("expanded")]), _vm._v(" prop "), _c('u', [_vm._v("on the control")]), _vm._v(" to "), _c('b', [_vm._v("fill up the remaining space")]), _vm._v(".")]), _vm._v(" "), _c('b-message', {
    attrs: {
      "type": "is-info"
    }
  }, [_c('b', [_vm._v("Note:")]), _vm._v(" Beware of its responsiveness, avoid large groups of addons since they don't break lines.\n            ")])], 1), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExGroups,
      "code": _vm.ExGroupsCode,
      "title": "Groups"
    }
  }, [_c('p', [_vm._v("You can group those components together with the "), _c('code', [_vm._v("grouped")]), _vm._v(" property.")]), _vm._v(" "), _c('p', [_vm._v("Use the "), _c('code', [_vm._v("expanded")]), _vm._v(" prop "), _c('u', [_vm._v("on the control")]), _vm._v(" to "), _c('b', [_vm._v("fill up the remaining space")]), _vm._v(".")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExGroupExpanded,
      "code": _vm.ExGroupExpandedCode,
      "title": "Nested groups"
    }
  }, [_c('p', [_vm._v("\n                Nested Fields can be grouped as well,\n                you have to use the "), _c('code', [_vm._v("expanded")]), _vm._v(" prop "), _c('u', [_vm._v("on the Field")]), _vm._v(" to "), _c('b', [_vm._v("fill up the remaining space")]), _vm._v(".\n            ")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExGroupMultiline,
      "code": _vm.ExGroupMultilineCode,
      "title": "Responsive groups",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("\n                Add the "), _c('code', [_vm._v("group-multiline")]), _vm._v(" prop to allow controls to fill up "), _c('b', [_vm._v("multiple lines")]), _vm._v(".\n                This is ideal for a long list of controls.\n            ")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExPositions,
      "code": _vm.ExPositionsCode,
      "title": "Positions"
    }
  }, [_c('p', [_vm._v("Add the "), _c('code', [_vm._v("position")]), _vm._v(" prop to modify its alignment.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExCombineAddonsGroups,
      "code": _vm.ExCombineAddonsGroupsCode,
      "title": "Combining addons and groups"
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExHorizontal,
      "code": _vm.ExHorizontalCode,
      "title": "Horizontal"
    }
  }, [_c('p', [_vm._v("Add the "), _c('code', [_vm._v("horizontal")]), _vm._v(" prop for aligning label and control in horizontal forms.")]), _vm._v(" "), _c('b-message', {
    attrs: {
      "type": "is-info"
    }
  }, [_c('b', [_vm._v("Note:")]), _vm._v(" Each child element of a "), _c('code', [_vm._v("<b-field horizontal/>")]), _vm._v(" will be\n                automatically wrapped inside a "), _c('code', [_vm._v("Field")]), _vm._v(" component.\n            ")])], 1), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExCustomClass,
      "code": _vm.ExCustomClassCode,
      "title": "Label classes"
    }
  }, [_c('p', [_vm._v("Add the "), _c('code', [_vm._v("custom-class")]), _vm._v(" prop to adjust the styling of the label.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExLabelSlot,
      "code": _vm.ExLabelSlotCode,
      "title": "Label slot"
    }
  }, [_c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag is-success"
  }, [_vm._v("New!")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v("0.7.6")])]), _vm._v(" "), _c('p', [_vm._v("Use the "), _c('code', [_vm._v("label")]), _vm._v(" slot for complex labels with HTML content or components. Note it overrides the "), _c('code', [_vm._v("label")]), _vm._v(" prop.")])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  }), _vm._v(" "), _c('VariablesView', {
    attrs: {
      "data": _vm.variables
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("These components should be used as a "), _c('strong', [_vm._v("direct child")]), _vm._v(" of Field:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Autocomplete")]), _vm._v(" "), _c('li', [_vm._v("Checkbox Button")]), _vm._v(" "), _c('li', [_vm._v("Datepicker")]), _vm._v(" "), _c('li', [_vm._v("Input")]), _vm._v(" "), _c('li', [_vm._v("Radio Button")]), _vm._v(" "), _c('li', [_vm._v("Select")]), _vm._v(" "), _c('li', [_vm._v("Taginput")]), _vm._v(" "), _c('li', [_vm._v("Timepicker")]), _vm._v(" "), _c('li', [_vm._v("Upload")]), _vm._v(" "), _c('li', [_c('code', [_vm._v(".control")]), _vm._v(" elements (html class)")])])])
}]}

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    props: [{
        name: '<code>type</code>',
        description: 'Type (color) of the field and help message, also adds a matching icon, optional. Used by Input, Select and Autocomplete',
        type: 'String, Object',
        values: '<code>is-white</code>, <code>is-black</code>, <code>is-light</code>,\n                    <code>is-dark</code>, <code>is-primary</code>, <code>is-info</code>, <code>is-success</code>,\n                    <code>is-warning</code>, <code>is-danger</code>,\n                    and any other colors you\'ve set in the <code>$colors</code> list on Sass',
        default: '—'
    }, {
        name: '<code>label</code>',
        description: 'Field label',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>label-for</code>',
        description: 'Same as native <code>for</code> set on the label',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>custom-class</code>',
        description: 'CSS classes to be applied on field label',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>message</code>',
        description: 'Help message text',
        type: 'String, Object, Array<String>, Array<Object>',
        values: '—',
        default: '—'
    }, {
        name: '<code>grouped</code>',
        description: 'Direct child components/elements of Field will be grouped horizontally (see which ones at the top of the page)',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>group-multiline</code>',
        description: 'Allow controls to fill up multiple lines, making it responsive',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>position</code>',
        description: 'Which position should the addons appear, optional',
        type: 'String',
        values: '<code>is-centered</code>, <code>is-right</code>',
        default: '—'
    }, {
        name: '<code>addons</code>',
        description: 'Field automatically attach controls together',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>horizontal</code>',
        description: 'Group label and control on the same line for horizontal forms',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>label-position</code>',
        description: 'Position of label',
        type: 'String',
        values: '<code>inside</code>, <code>on-border</code>',
        default: '-'
    }],
    slots: [{
        name: '<code>label</code>',
        description: 'Custom label',
        props: '-'
    }]
}]);

/***/ }),

/***/ 175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    name: '<code>$floating-in-height</code>',
    default: '<code>3.25em</code>'
}]);

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1073),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1074),
  /* template */
  __webpack_require__(1075),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1076),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1077),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1078),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1079),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1080),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1081),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1082),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1083),
  /* template */
  __webpack_require__(1084),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1085),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1086),
  /* template */
  __webpack_require__(1087),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1391),
  /* template */
  __webpack_require__(1404),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/5.ee5e435fe087d432e585.js